/*
 * File: enums.ts
 * Created: 2025-10-25 17:15:40
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2026-02-10 15:59:59
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

export enum ETranslationFromLang {
    "auto" = "w_LangAuto",
    "en" = "w_LangEnglish",
    "ja" = "w_LangJapanese",
    "zh-TW" = "w_LangTraditionalChinese",
    "zh-CN" = "w_LangSimplifiedChinese",
    "fr" = "w_LangFrench",
    "th" = "w_LangThai",
    "id" = "w_LangIndonesian",
    "vi" = "w_LangVietnamese",
}

export enum ETranslationToLang {
    "en" = "w_LangEnglish",
    "ja" = "w_LangJapanese",
    "zh-TW" = "w_LangTraditionalChinese",
    "zh-CN" = "w_LangSimplifiedChinese",
    "fr" = "w_LangFrench",
    "th" = "w_LangThai",
    "id" = "w_LangIndonesian",
    "vi" = "w_LangVietnamese",
}

export enum EFileKind {
    "WORD" = "w_FileKindWord",
    "EXCEL" = "w_FileKindExcel",
    "POWERPOINT" = "w_FileKindPowerPoint",
}

export enum EPlatformRole {
    "ADMIN" = "w_UserRoleAdmin",
    "BILLING_ADMIN" = "w_UserRoleBillingAdmin",
    "USER" = "w_UserRoleUser",
}

export enum EAccountProvider {
    "credentials" = "w_AccountProviderCredentials",
    "ldap" = "w_AccountProviderLdap",
    "google" = "w_AccountProviderGoogle",
}

export enum EAccountTitleName {
    "credentials" = "w_AccountLocalName",
    "ldap" = "w_AccountLdapName",
    "google" = "w_AccountGoogleName",
}

export enum EOrganizationType {
    "PERSONAL" = "w_OrganizationTypePersonal",
    "ORG" = "w_OrganizationTypeOrg",
}

export enum EOrganizationTitleName {
    "PERSONAL" = "w_OrganizationPersonalName",
    "ORG" = "w_OrganizationOrgName",
}

export enum EMembershipRole {
    "ADMIN" = "w_MembershipRoleAdmin",
    "MEMBER" = "w_MembershipRoleMember",
}

export enum EPromotionCodeType {
    "CREDIT" = "w_PromotionCodeCredit",
    "DISCOUNT" = "w_PromotionCodeDiscount",
}

export enum EPromotionCodeDiscountType {
    "PERCENT" = "w_PromotionCodeDiscountTypePercent",
    "AMOUNT" = "w_PromotionCodeDiscountTypeAmount",
}

export enum ELedgerSource {
    "USER_DEPOSIT" = "w_LedgerSourceDeposit",
    "PROMO_CREDIT" = "w_LedgerSourcePromoCredit",
    "USAGE_DEBIT" = "w_LedgerSourceUsageDebit",
    "REFUND" = "w_LedgerSourceRefund",
}
